/* Survols de la carte Geotab : même apparence que les hovercards du SaaS. */
.leaflet-tooltip.geotab-hovercard {
  max-width: 300px;
  width: max-content;
  padding: 6px 10px;
  border: 0.5px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  color: #334155;
  font: 12px/1.55 "Plus Jakarta Sans", "Segoe UI", sans-serif;
  white-space: normal;
}
.leaflet-tooltip-top.geotab-hovercard::before { border-top-color: #fff; }
.leaflet-tooltip-bottom.geotab-hovercard::before { border-bottom-color: #fff; }
.leaflet-tooltip-left.geotab-hovercard::before { border-left-color: #fff; }
.leaflet-tooltip-right.geotab-hovercard::before { border-right-color: #fff; }
.geotab-hovercard .geotab-hovercard-title {
  display: block;
  margin-bottom: 2px;
  padding-bottom: 2px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.07);
  color: #64748b;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

/* Carte « Loin de l'adresse » : noms et distance toujours affichés, en étiquettes foncées lisibles sur tout fond. */
.leaflet-tooltip.geotab-place-label {
  padding: 2px 6px;
  border: 0;
  border-radius: 4px;
  background: rgba(17, 24, 39, 0.9);
  box-shadow: none;
  color: #fff;
  font: 600 11.5px/1.4 "Plus Jakarta Sans", "Segoe UI", sans-serif;
  width: max-content;
  max-width: 210px;
  white-space: normal;
}
.leaflet-tooltip.geotab-place-label::before { display: none; }
